import { Dayjs } from 'dayjs';
import { Frequency } from '../../../dataobject/types';

export function getPeriod(
  value: Dayjs,
  frequency?: Frequency,
  userFollowedGroupPeriodSkipCount?: number,
): [Dayjs, Dayjs];
export function getPeriod(
  value: Dayjs | null,
  frequency?: Frequency,
  userFollowedGroupPeriodSkipCount?: number,
): [Dayjs, Dayjs] | [null, null];
export function getPeriod(
  value: Dayjs | null,
  frequency?: Frequency,
  userFollowedGroupPeriodSkipCount: number = 0,
): [null, null] | [Dayjs, Dayjs] {
  if (!value) {
    return [null, null];
  }
  let begin;
  switch (frequency) {
    case 'HALFYEAR': {
      const adjustedValue = value.subtract(
        userFollowedGroupPeriodSkipCount * 6,
        'month',
      );
      begin =
        adjustedValue.month() < 6
          ? adjustedValue.startOf('year')
          : adjustedValue.startOf('year').add(6, 'months');
      return [
        begin.startOf('day'),
        begin.add(6, 'months').add(-1, 'days').startOf('day'),
      ];
    }
    case 'QUARTER':
      begin = value
        .startOf('quarter')
        .subtract(userFollowedGroupPeriodSkipCount, 'quarter')
        .startOf('day');
      return [begin, begin.endOf('quarter')];
    case 'MONTH':
      begin = value
        .startOf('month')
        .subtract(userFollowedGroupPeriodSkipCount, 'month')
        .startOf('day');
      return [begin, begin.endOf('month')];
    case 'WEEK':
      begin = value
        .startOf('isoWeek')
        .subtract(userFollowedGroupPeriodSkipCount, 'week')
        .startOf('day');
      return [begin, begin.endOf('isoWeek')];
    case 'YEAR':
      begin = value
        .startOf('year')
        .subtract(userFollowedGroupPeriodSkipCount, 'year')
        .startOf('day');
      return [begin, begin.endOf('year')];
    default:
      return [value, value];
  }
}

export function getPrevPeriodEnd(
  value: Dayjs,
  frequency?: Frequency,
  userFollowedGroupPeriodSkipCount?: number,
): Dayjs;
export function getPrevPeriodEnd(
  value: Dayjs | null,
  frequency?: Frequency,
  userFollowedGroupPeriodSkipCount?: number,
): Dayjs | null {
  if (!value) {
    return null;
  }

  let previousPeriod;
  switch (frequency) {
    case 'HALFYEAR':
      previousPeriod = value.add(-6, 'months');
      break;
    case 'QUARTER':
      previousPeriod = value.add(-1, 'quarters');
      break;
    case 'MONTH':
      previousPeriod = value.add(-1, 'months');
      break;
    case 'WEEK':
      previousPeriod = value.add(-1, 'weeks');
      break;
    case 'YEAR':
      previousPeriod = value.add(-1, 'years');
      break;
    default:
      previousPeriod = value.add(-1, 'days');
      break;
  }

  return getPeriod(
    previousPeriod,
    frequency,
    userFollowedGroupPeriodSkipCount,
  )[1];
}

export function getNextPeriodEnd(value: Dayjs, frequency?: Frequency): Dayjs;
export function getNextPeriodEnd(
  value: Dayjs | null,
  frequency?: Frequency,
): Dayjs | null {
  if (!value) {
    return null;
  }

  let previousPeriod;
  switch (frequency) {
    case 'HALFYEAR':
      previousPeriod = value.add(6, 'months');
      break;
    case 'QUARTER':
      previousPeriod = value.add(1, 'quarters');
      break;
    case 'MONTH':
      previousPeriod = value.add(1, 'months');
      break;
    case 'WEEK':
      previousPeriod = value.add(1, 'weeks');
      break;
    case 'YEAR':
      previousPeriod = value.add(1, 'years');
      break;
    default:
      previousPeriod = value.add(1, 'days');
      break;
  }

  return getPeriod(previousPeriod, frequency)[1];
}

export type DatePickerMode =
  | 'time'
  | 'date'
  | 'year'
  | 'quarter'
  | 'month'
  | 'week'
  | undefined;

export function getDatePickerMode(frequency?: Frequency): DatePickerMode {
  switch (frequency) {
    case 'HALFYEAR':
      return 'quarter';
    case 'YEAR':
      return 'year';
    case 'QUARTER':
      return 'quarter';
    case 'MONTH':
      return 'month';
    case 'WEEK':
      return 'week';
    default:
      return 'date';
  }
}
